"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupCtrl = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const modal_service_1 = require("../../components/modal/modal.service");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const index_1 = require("../../i18n/index");
const page_1 = require("../../page/page");
const services_1 = require("../../services");
const user_service_1 = require("../../services/user.service");
class SignupCtrl {
    constructor(success) {
        this.loading = false;
        this.invalidEmail = null;
        this.success = success;
    }
    signupSSO(inviteToken, firstname, lastname) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            this.setLoading(true);
            try {
                this.success(yield user_service_1.UserMutator.createSSO(inviteToken, firstname, lastname));
            }
            catch (e) {
                if (((_b = (_a = e.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.field) === 'email' && ((_d = (_c = e.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.codes) === 'already_exists') {
                    modal_service_1.ModalService.close();
                    const result = yield modal_service_1.ModalService.open({
                        title: (0, index_1.Translate)(index_1.T.USER_ALREADY_EXISTS),
                        content: (0, index_1.Translate)(index_1.T.USER_ALREADY_EXISTS_DESCRIPTION),
                        hasCancel: false,
                        okName: index_1.T.LOGIN
                    });
                    if (result.ok) {
                        services_1.Services.SSO.login({
                            redirect_uri: window.location.origin + services_1.Services.Route.getRouteURL(page_1.IkePageName.acceptInvite, { inviteToken })
                        });
                    }
                }
                else {
                    notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
                }
            }
            finally {
                this.setLoading(false);
            }
        });
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setInvalidEmail(invalidEmail) {
        this.invalidEmail = invalidEmail;
    }
}
exports.SignupCtrl = SignupCtrl;
tslib_1.__decorate([
    mobx_1.observable
], SignupCtrl.prototype, "loading", void 0);
tslib_1.__decorate([
    mobx_1.observable
], SignupCtrl.prototype, "invalidEmail", void 0);
tslib_1.__decorate([
    mobx_1.action
], SignupCtrl.prototype, "setLoading", null);
tslib_1.__decorate([
    mobx_1.action
], SignupCtrl.prototype, "setInvalidEmail", null);
//# sourceMappingURL=signup.ctrl.js.map